// @flow
import type { Element } from 'react';

import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import Header from '#components/support/layout/Header/index.js';
import Main from '#components/support/layout/MainPageContainer/index.jsx';
import Page from '#components/support/layout/Page/index.js';
import ModelsTable from '#components/pages/Models/Dashboard/ModelsTable/index.js';
import ModelsMap from '#components/pages/Models/Dashboard/ModelsMap/index.js';
import CreateModelButton from '#components/pages/Models/Dashboard/CreateModelButton/index.js';
import { ActionRow } from '#components/support/layout/ActionRow/index.jsx';
import { setDashboardView } from '#actions/models/modelsTable.js';
import { selectDashboardView } from '#selectors/ui/modelsTable.js';
import ModelsFilterForm from './ModelsFilterForm/index.js';

type Props = {
  includeHeader?: boolean,
  view: string,
  onSetView: (view: string) => void,
};

const ModelsPage = ({ includeHeader = true, view, onSetView }: Props): Element<typeof Page> => (
  <Page className="models-dashboard-page">
    {includeHeader && <Header />}
    <Main withRoomForHeader={includeHeader !== false}>
      <Row>
        <Col md="12" className="col">
          <h1>Models</h1>
        </Col>
      </Row>
      <ActionRow>
        <Col md="12" className="col">
          <div className="float-right d-flex align-items-center">
            <ButtonGroup size="sm" className="mr-3">
              <Button
                color={view === 'table' ? 'secondary' : 'outline-secondary'}
                onClick={() => onSetView('table')}
              >
                Table
              </Button>
              <Button
                color={view === 'map' ? 'secondary' : 'outline-secondary'}
                onClick={() => onSetView('map')}
              >
                Map
              </Button>
            </ButtonGroup>
            <CreateModelButton color="link">Create Model +</CreateModelButton>
          </div>
        </Col>
      </ActionRow>
      <Row>
        <Col md="12" className="col">
          <ModelsFilterForm />
        </Col>
      </Row>
      <Row>
        <Col md="12" className="col">
          {view === 'map' ? <ModelsMap /> : <ModelsTable />}
        </Col>
      </Row>
    </Main>
  </Page>
);

const mapStateToProps = (state): {| view: string |} => ({
  view: selectDashboardView(state),
});

const mapDispatchToProps = (dispatch): ({| onSetView: (view: string) => void |}) => ({
  onSetView: view => dispatch(setDashboardView(view)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(ModelsPage): any);
